<script>
    export let src = '';
</script>

<style type="text/scss">
  img {
    display: block;
    height: calc(100vh - 6rem);
  }
</style>

<img alt="image" src={src}/>